import React from "react"
import PropTypes from "prop-types"
import clsx from "classnames"
import {
  BarChart3,
  Newspaper,
  PenSquare,
  Settings,
  SquareArrowDown,
  SquarePlus,
} from "lucide-react"

const ActionIcon = ({ name, small }) => {
  const commonProps = {
    className: clsx("-ml-1/2 pr-1", {
      "w-4": small,
      "w-5": !small,
    }),
  }

  switch (name) {
    case "edit":
      return <PenSquare {...commonProps} />
    case "chart":
      return <BarChart3 {...commonProps} />
    case "readers": // topic sponsorships
      return <SquarePlus {...commonProps} />
    case "article":
      return <Newspaper {...commonProps} />
    case "republish": // merge topic
      return <SquareArrowDown {...commonProps} />
    default:
      return <Settings {...commonProps} />
  }
}

ActionIcon.propTypes = {
  name: PropTypes.string,
  small: PropTypes.bool,
}

export default ActionIcon
